export default __webpack_public_path__ + "static/media/nsm.422c3712.png";